import { Button, TableRow, TableCell, Collapse } from "@material-ui/core";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./styles";
import moment from "moment";
import Snackbar from "../../snackbar";
import Loading from "../../loading";
import Header from "../../../partials/header";
import TableFormat from "../../../partials/TableFormat";
import PriceFormat from "../../../partials/priceFormat";
import EditNote from "./editNote";
import queryString from "query-string";

const headCells = [
  {
    key: "orderCode",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_order_code",
  },
  {
    key: "branchName",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_branch",
  },
  {
    key: "listItem",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_item",
  },
  {
    key: "totalPrice",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_price",
  },
  {
    key: "memberCardMoney",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_membercard_money",
  },
  {
    key: "status",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_status",
  },
];
const status = [
  {
    value: "new",
    label: "new",
    color: "rgb(45, 148, 178)",
  },
  {
    value: "processing",
    label: "processing",
    color: "rgb(225, 210, 36)",
  },
  {
    value: "cancel",
    label: "cancel",
    color: "rgb(208, 53, 53)",
  },
  {
    value: "done",
    label: "done",
    color: "rgb(130, 193, 77)",
  },
  {
    value: "abort",
    label: "abort",
    color: "rgb(208, 53, 53)",
  },
];
class DetailUserMemberCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: [],
    };
  }
  componentDidMount() {
    this.getByCode();
  }
  getByCode = async (payload) => {
    const { location } = this.props;
    const parsed = queryString.parse(location.search);
    let data = {
      memberCardCode: parsed._id,
      countryCode: "+" + parsed.countryCode.replace(" ", ""),
      mobile: parsed.mobile,
      ...payload,
    };
    this.loading.startLoading();
    await this.props.getByCode(data);
    this.loading.stopLoading();
  };
  findBranchName(orderCode) {
    let { listOrder, listBranch, t } = this.props;
    let result = listOrder.find((order) => order.orderCode === orderCode);
    if (result) {
      let { item } = result;
      return item.map((ele, i) => {
        if (ele.forAll === 1) {
          let newArrBranch = [
            { branchName: t("listOrder_apply_for_all_branches") },
          ];
          return newArrBranch.map((branch, z) => {
            return <div key={i}>{branch.branchName}</div>;
          });
        } else {
          let newArrBranch = [];
          ele.arrBranch.forEach((branchCode, i) => {
            let findBranchName = listBranch.find(
              (branch) => branch.branchCode === branchCode
            );
            if (findBranchName)
              newArrBranch.push({ branchName: findBranchName.branchName });
          });
          return newArrBranch.map((branch, z) => {
            return <div key={z}>{branch.branchName}</div>;
          });
        }
      });
    } else {
      return <div></div>;
    }
  }
  changeFormat(datetime) {
    return moment(datetime).format("DD/MM/YYYY hh:mm:ss A");
  }
  handleOpenCollapes = (id) => {
    const { listOrder = [] } = this.props;
    const collapse = this.state.collapse;
    for (let i = 0; i <= listOrder.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState(collapse);
  };
  renderStatus = (order) => {
    const { classes, t } = this.props;
    return status.map((item, index) => {
      if (item.value === order.status)
        return (
          <Button
            key={index}
            classes={{
              root: classes.btnStatus,
            }}
            size="small"
            style={{ backgroundColor: item.color, color: "#fff" }}
          >
            {t(item.label)}
          </Button>
        );
      return "";
    });
  };
  renderCollapse = (row, index) => {
    const { classes, listOrder } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow className={classes.tableRowHeight}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditNote
              item={index}
              data={listOrder[index]}
              handleSubmit={this.handleSubmit}
              {...this.props}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  render() {
    const {
      t,
      classes,
      listOrder,
      userMemberCard,
      i18n,
      location,
    } = this.props;
    const { collapse } = this.state;
    const parsed = queryString.parse(location.search);
    let title;
    if (i18n.language === "vn") {
      title = !userMemberCard.customerName
        ? `${t("user_membercard_users_card")} ${t("user_membercard_users")}(${
            userMemberCard.countryCode
          }${userMemberCard.mobile})`
        : `${t("user_membercard_users_card")} ${t("user_membercard_users")}: ${
            userMemberCard.customerName
          }(${userMemberCard.countryCode} ${userMemberCard.countryCode}${
            userMemberCard.mobile
          })`;
    } else {
      title = !userMemberCard.customerName
        ? `${t("user_membercard_users")}(${userMemberCard.countryCode}${
            userMemberCard.mobile
          })${t("user_membercard_users_card")}`
        : `${userMemberCard.customerName}(${userMemberCard.countryCode}${
            userMemberCard.mobile
          })${t("user_membercard_users_card")}`;
    }
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Header
          session={t("user_membercard_history_membercard")}
          title={`${title} #${parsed._id}`}
          backIcon={true}
          actionBack={() =>
            this.props.history.push("/promotion/userMembercard/list")
          }
        />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          title={t("orders_order")}
          showFilter={false}
          showActionToolbar={false}
          hiddenPagination={true}
          hiddenInfoRcord={true}
          showCheckBox={false}
          placeholder={t("user_membercard_history_search_by_order_code")}
          headCells={headCells}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getByCode}
          rows={listOrder.map((row, index) => {
            let updateAt = this.changeFormat(row.updatedAt);
            return {
              id: row.orderCode,
              orderCode: (
                <div className={classes.customColumn}>
                  <div>{row.orderCode}</div>
                  <div className={classes.updatedAtRow}>{updateAt}</div>
                </div>
              ),
              branchName: row.branchName
                ? row.branchName
                : this.findBranchName(row.orderCode),
              listItem: row.item.map((item) => item.itemName).join(", "),
              totalPrice: (
                <PriceFormat
                  value={`${row.totalPrice} ${this.props.currencyCode}`}
                  priceType={row.totalPrice < 0 ? "warning" : "regular"}
                />
              ),
              memberCardMoney: row.calcMemberCards && (
                <PriceFormat
                  value={`${row.calcMemberCards} ${this.props.currencyCode}`}
                  priceType="regular"
                />
              ),
              status: this.renderStatus(row),
            };
          })}
        />
      </React.Fragment>
    );
  }
}

DetailUserMemberCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  listOrder: state.userMembercard.listOrderUserMembercard,
  userMemberCard: state.userMembercard.userMemberCard,
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({
  getByCode: dispatch.userMembercard.getDetailByCode,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(DetailUserMemberCard)));
